import { render } from "./ModalRecursoAgregar.vue?vue&type=template&id=f570a3d0&scoped=true"
import script from "./ModalRecursoAgregar.vue?vue&type=script&lang=js"
export * from "./ModalRecursoAgregar.vue?vue&type=script&lang=js"

import "@/assets/styles/modal-styles.css?vue&type=style&index=0&id=f570a3d0&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f570a3d0"]])

export default __exports__